import React, { FunctionComponent, useState } from 'react';
import { ButtonOutlinePrimary, useSnackbar } from '../../components-v2/shared';
import styles from './blast-schedule-editor.module.scss';
import { SmsTestModal } from '../EmailEditor/EmailEditorComponents/SmsTestModal';
import { handlePromise } from '../../util/async';
import { observer } from 'mobx-react';
import useStore from '../../store/useStore';
import { BlastScheduleEditorEditScheduleReducerAction, ServerRequestStatus } from './BlastScheduleEditor.helpers';

export const BlastScheduleSendSmsTestButton: FunctionComponent<{
    dispatch: (action: BlastScheduleEditorEditScheduleReducerAction) => void;
    testSmsStatus: ServerRequestStatus;
    disabled: boolean;
    smsMessage?: string | null;
    companyPhone?: string;
}> = observer(({ dispatch, testSmsStatus, disabled, smsMessage, companyPhone }) => {
    const { store } = useStore();
    const { router, Api } = store;
    const { companyId, scheduleId } = router.params;
    const { addSnackbar } = useSnackbar();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Only show button if SMS message has content
    const hasSmsContent = smsMessage && smsMessage.trim().length > 0;

    const handleSendSmsTest = async (phoneNumber: string) => {
        console.log('handleSendSmsTest called with phone number:', phoneNumber);
        dispatch({ name: 'updateTestSmsStatus', payload: 'sending' });

        const [, error] = await handlePromise(
            Api.client.post(`company/${companyId}/blast-schedules/${scheduleId}/test-sms`, {
                phoneNumber: phoneNumber
            })
        );

        if (error) {
            dispatch({ name: 'updateTestSmsStatus', payload: 'error' });
            addSnackbar('Failed to send test SMS. Please try again.', { variant: 'error' });
            return;
        }

        dispatch({ name: 'updateTestSmsStatus', payload: 'sent' });
        addSnackbar(`Test SMS was sent to ${phoneNumber}.`, { variant: 'success' });
        setTimeout(() => dispatch({ name: 'updateTestSmsStatus', payload: 'waiting' }), 5000);
        setIsModalOpen(false);
    };

    const buttonText = {
        waiting: 'Send SMS Test',
        sending: 'Sending...',
        sent: 'Sent!',
        error: 'Try Again'
    };

    if (!hasSmsContent) {
        return null; // Don't render if no SMS content
    }

    return (
        <>
                <ButtonOutlinePrimary
                    type="button"
                    className={styles['blast-schedule-editor-test-button']}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log('SMS Button clicked - should open modal, NOT call API');
                        setIsModalOpen(true);
                    }}
                    disabled={testSmsStatus === 'sending' || testSmsStatus === 'sent' || disabled}
                >
                    {buttonText[testSmsStatus]}
                </ButtonOutlinePrimary>
            <SmsTestModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSendSms={handleSendSmsTest}
                defaultPhoneNumber={companyPhone || ''}
                isLoading={testSmsStatus === 'sending'}
            />
        </>
    );
});
